import request from '@/utils/request'

const getCourseById = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/course/${id}`,
    method: 'get'
  })
}

const getCoursePageListStudent = (query) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/course/page-list-student`,
    method: 'get',
    params: query
  })
}

function createCourse(data) {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/course`,
    method: 'post',
    data
  })
}

const updateCourse = (id, data) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/course/${id}`,
    method: 'put',
    data
  })
}

export default {
  createCourse,
  updateCourse,
  getCourseById,
  getCoursePageListStudent
}
